import { Accessor, UpdateParameters } from '@deck.gl/core';
import { Texture } from '@luma.gl/core';
import { positionTextureLineModule, positionTextureLineModuleName } from '../../modules/coast-position-texture.js';
import { LeaderLineLayer } from './leader-line-layer.js';

export class AnimatedLeaderLineLayer<TData> extends LeaderLineLayer<
    TData,
    {
        positionTexture: Texture | null;
        getId: Accessor<TData, number>;
    }
> {
    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, positionTextureLineModule]
        };
    }

    initializeState() {
        super.initializeState();
        this.getAttributeManager()!.remove(['instanceSourcePositions']);
        this.getAttributeManager()!.addInstanced({
            instanceId: {
                size: 1,
                type: 'uint32',
                accessor: 'getId'
            }
        });
    }

    updateState(params: UpdateParameters<this>): void {
        super.updateState(params);
        if (params.changeFlags.propsChanged) {
            this.state.model?.shaderInputs.setProps({
                [positionTextureLineModuleName]: this.props
            });
        }
    }
}
